import { pick } from "lodash";
import {
  CreateTransactionsObject,
  Frequency,
  TRANSACTION_TYPE_MAP,
} from "../../pages/Transactions";
import { formatDate } from "../../utils/strings";
import { CreateRecurringTransactionPayload } from "./types";

export const transformRecurringTransactionPayload = (
  transaction: CreateTransactionsObject,
): CreateRecurringTransactionPayload => {
  if (!transaction.frequency || !transaction.interval) {
    throw new Error(
      "Frequency and interval are required for recurring transactions",
    );
  }

  let payload: CreateRecurringTransactionPayload = {
    // Recurring DTOs reject one-off fields such as cashback and tax overrides.
    ...pick(transaction, ["note"]),
    frequency: transaction.frequency.value as Frequency,
    startDate: formatDate(transaction.transactionDate),
    transactionType: TRANSACTION_TYPE_MAP[transaction.transactionType.value],
    amount: Number.parseFloat(transaction.amount),
    interval: transaction.interval,
  };

  if (
    transaction.stopAfterOccurrences &&
    !Number.isNaN(transaction.stopAfterOccurrences)
  ) {
    payload.stopAfterOccurrences = transaction.stopAfterOccurrences;
  } else {
    payload.stopAfterOccurrences = undefined;
  }

  if (transaction.fromAccount) {
    payload.fromAccountId = Number(transaction.fromAccount.value);
  } else {
    payload.fromAccountId = undefined;
  }

  if (transaction.toAccount) {
    payload.toAccountId = Number(transaction.toAccount.value);
  } else {
    payload.toAccountId = undefined;
  }

  if (transaction.subCategory) {
    payload.subCategoryId = Number(transaction.subCategory.value);
  } else {
    payload.subCategoryId = undefined;
  }

  if (transaction.category) {
    payload.categoryId = Number(transaction.category.value);
  } else {
    payload.categoryId = undefined;
  }

  return payload;
};
